<div style="margin-top: 104px;text-align: center;">
    <h1>
        Successfully authenticated!
    </h1>
    <p>You can go back to what you were working on in Editorial Owl. This page is safe to close.</p>
</div>
